<template>
    <div class="date settings-section">
        <p class="settings-section__heading">{{ $t('project_settings.lead.lead_time') }}</p>
        <div class="date__wrapper">
            <div class="date__left">
                <div class="date__item">
                    <p>{{ $t('project_settings.lead.project_start') }}</p>
                    <Datepicker class="datepicker-input"
                                v-model="projectDetails.startDate"
                                placeholder="dd.mm.rrrr"
                                format="dd.MM.yyyy"
                                previewFormat="dd.MM.yyyy"
                                :locale="$i18n.locale"
                                uid="date"
                                hideInputIcon
                                :enableTimePicker="false"
                                :ariaLabels="{ menu: $t('project_settings.lead.date_label_aria')}"
                                :selectText="$t('project_settings.lead.ok_label')"
                                :cancelText="$t('project_settings.lead.cancel_label')"
                    ></Datepicker>
                </div>
                <div class="date__item">
                    <p>{{ $t('project_settings.lead.project_deadline') }}</p>
                    <Datepicker class="datepicker-input"
                                v-model="projectDetails.deadline"
                                placeholder="dd.mm.rrrr"
                                format="dd.MM.yyyy"
                                previewFormat="dd.MM.yyyy"
                                :locale="$i18n.locale"
                                uid="date"
                                hideInputIcon
                                :enableTimePicker="false"
                                :ariaLabels="{ menu: $t('project_settings.lead.date_label_aria')}"
                                :selectText="$t('project_settings.lead.ok_label')"
                                :cancelText="$t('project_settings.lead.cancel_label')"
                    ></Datepicker>
                </div>
            </div>
            <div class="date__right">
                <img src="@/assets/images/lead-time.png" :alt="$t('project_settings.lead.lead_time_img')" />
            </div>
            <div class="date__button project-add__button furniture__button">
                <button @click="saveDate">{{ $t('project_settings.lead.save') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import {useProjectsStore} from "@/stores/user/projects.store";
import {storeToRefs} from "pinia";
import {useI18n} from "vue-i18n";
import router from "@/router";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import {inject, reactive, ref, toRefs, watch} from "vue";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import "@/css/project-settings.scss";
import "@/css/custom-project-settings.scss";
import AlertHelper from "@/helpsers/alert.helper";

export default {
    name: "LeadTime",
    components: {
        Datepicker
    },
    props: {
        project: {
            type: Object,
            default: null
        }
    },
    setup(props) {
        const {t} = useI18n(),
            alert = inject('alert');
        const { project: projectDetails } = toRefs(props)

        function saveDate() {
            const data = {
                id: router.currentRoute.value.params.id,
                deadline: projectDetails.value.deadline,
                startDate: projectDetails.value.startDate,
            }

            axios.put(ApiHelper.getEditProjectUrl(),data, {
                headers: authHelper.authHeader()
            })
                .then((result) => {
                    AlertHelper.show(alert, t('project_settings.lead.save_success_title'));
                })
                .catch(({response}) => {
                    let errorMessage = ApiHelper.getResponseMessage(response?.data?.code);
                    AlertHelper.show(alert, errorMessage, '', 'error');
                })
        }

        return {
            projectDetails,
            saveDate
        }
    }
}
</script>

<style scoped lang="scss">
.date {
    &__wrapper {
        flex-wrap: wrap;
    }
    &__button {
        width: 100%;
        text-align: right;
        margin: 10px 0;
        z-index: 1;

        @media screen and (max-width: 500px) {
            text-align: center;
        }

        button {
            &:hover {
                cursor: pointer;
                background: #e35748;
            }
        }

    }
}
</style>